var map = {
	"./en.json": 6519
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 3 | 16);;
	});
}
function webpackAsyncContextResolve(req) {
	return Promise.resolve(/* lazy-once context */).then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 38620;
module.exports = webpackAsyncContext;